export default __webpack_public_path__ + "static/media/SepaLogoEN.90f51f31.jpg";